import React from 'react';

import formatTable from '../../helpers/formatTable';

class CountryProfileSubSectionAnswer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      content: formatTable(props.content || [])
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      content: formatTable(nextProps.content || [])
    });
  }

  renderTdList(list) {
    return list.map((item, index) => {
      return (
        <td key={ index } colSpan={ item.colspan }>
          { item.text }
        </td>
      );
    });
  }

  renderTrList() {
    const content = this.state.content;

    return content.map((item, index) => {
      return (
        <tr key={ index }>{ this.renderTdList(item) }</tr>
      );
    });
  }

  render() {
    let className = this.props.className || "";
    className = `table table-responsive table-bordered country-profile__section-table ${className}`;

    return (
      <table className={ className }>
        <tbody>
          { this.renderTrList() }
        </tbody>
      </table>
    );
  }
}

export default CountryProfileSubSectionAnswer;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSubSectionTable.js